var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEinfacherPfeilrunterGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.26 11.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#737373;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigationselemenete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    className: "cls-1",
    d: "M10.13,8.1L17.79,.43c.56-.56,1.48-.57,2.04,0,0,0,0,0,0,0,.56,.57,.56,1.48,0,2.05L11.15,11.17c-.55,.55-1.43,.57-2,.04L.41,2.48C-.15,1.91-.14,.99,.44,.43c.56-.55,1.46-.55,2.02,0l7.67,7.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEinfacherPfeilrunterGrau);
export default __webpack_public_path__ + "static/media/einfacher Pfeil runter_grau.4f68c7a3229bb9b6c204cddf0330dccb.svg";
export { ForwardRef as ReactComponent };